import { render, staticRenderFns } from "./modalovertimepayrollitem.vue?vue&type=template&id=881fc7d6"
import script from "./modalovertimepayrollitem.vue?vue&type=script&lang=js"
export * from "./modalovertimepayrollitem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports